enum CustomerTypes {
    PRIVATE = 'PR',
    BUSINESS = 'BU',
}

enum CustomerTypesKeys {
    PRIVATE = 'PRIVATE',
    BUSINESS = 'BUSINESS',
}

enum CustomerTypesUrl {
    PR = 'privati',
    BU = 'clienti-business',
}

export {CustomerTypesUrl, CustomerTypesKeys}

export default CustomerTypes
